import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const Logout = ({ setUserId }) => {
    const navigate = useNavigate();

    useEffect(() => {
        document.cookie = 'authToken=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
        document.cookie = 'userId=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';

        setUserId(null);

        navigate('/login');
    }, [navigate, setUserId]);

    return null;
};

export default Logout;
